import { FeedIndex } from "@ethersphere/bee-js";

export const DEFAULT_BEE_URL = "http://localhost:1633";
export const FEED_INDEX_ZERO = FeedIndex.fromBigInt(0n);
